import Dialog from '@mui/material/Dialog';
import { useCallback, useState } from 'react';
import ThemeConstants from '../../../../config/theme/theme_constants';
import { useTranslation } from '../../../../i18n/useTranslation';

interface RestartDialogProps {
    onClose: () => void;
    open: boolean;
    onValidate: (filters: string[]) => void;
}

const FiltersDialog: React.FC<RestartDialogProps> = ({ onClose, open, onValidate }) => {
    const { t } = useTranslation();
    const filters = [
        { label: t('rewards.filters.gift'), value: "gift" },
        { label: t('rewards.filters.activity'), value: "activity" },
        { label: t('rewards.filters.impact_project'), value: "impact_project" },
        { label: t('rewards.filters.privileged_access'), value: "privileged_access" },
    ];
    const theme = ThemeConstants();
    const [ selectedFilters, setFilters ] = useState<string[]>([]);

    const toggleFilter = useCallback((filterValue: string) => {
        setFilters(prev => {
            if (prev.includes(filterValue)) {
                return prev.filter(f => f !== filterValue);
            } else {
                return [...prev, filterValue];
            }
        });
    }, [setFilters]);

    const isFilterSelected = useCallback((filterValue: string) => {
        return selectedFilters.includes(filterValue);
    }, [selectedFilters]);

    return (
        <Dialog
            fullWidth={true}
            onClose={onClose}
            open={open}
            slotProps={{
                backdrop: {
                    style: {
                        backgroundColor: 'rgba(0, 0, 0, 0.75)',
                    },
                },
                container: {
                    className: '!w-screen'
                },
                paper: {
                    className: '!rounded-[20px] !m-3 !w-full',
                },
            }}
        >
            <div className='flex flex-col items-center gap-7 w-full bg-white px-9 pt-15.5 pb-11.5'>
                <div className="flex flex-col items-center gap-6 text-black">
                    <h2 className='text-xl font-medium text-center'>{t('rewards.filters.title')}</h2>
                </div>
                
                <div className="grid grid-cols-2 gap-3 w-full">
                    {filters.map((filter) => (
                        <button
                            key={filter.value}
                            className={`rounded-2xl font-medium px-4 py-3 cursor-pointer transition-all duration-200 text-sm text-center min-h-[60px] flex items-center justify-center ${
                                isFilterSelected(filter.value)
                                    ? 'shadow-md'
                                    : 'shadow-sm'
                            }`}
                            style={{
                                backgroundColor: isFilterSelected(filter.value) 
                                    ? theme.UvibesPink 
                                    : theme.backgroundColor,
                                color: isFilterSelected(filter.value) 
                                    ? 'white' 
                                    : theme.UvibesPink,
                                boxShadow: isFilterSelected(filter.value)
                                    ? `0 4px 12px rgba(0, 0, 0, 0.15)`
                                    : `inset 0 0 0 1px ${theme.UvibesPink}`,
                            }}
                            onClick={() => toggleFilter(filter.value)}
                        >
                            {filter.label}
                        </button>
                    ))}
                </div>

                <button
                    className='rounded-full font-bold px-8 py-2.25 cursor-pointer w-full'
                    style={{
                        backgroundColor: theme.backgroundColor,
                        color: theme.UvibesPink,
                        boxShadow: `inset 0 0 0 1px ${theme.UvibesPink}`
                    }}
                    onClick={() => onValidate(selectedFilters)}
                >
                    {t('rewards.filters.confirm', { count: selectedFilters.length })}
                </button>
            </div>
        </Dialog>
    );
}

export default FiltersDialog;